import { Component, OnInit,OnDestroy, CUSTOM_ELEMENTS_SCHEMA, ViewChild, ElementRef, Inject, NgZone   } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { CommonapiService } from '../../Service/Commonapi.service';
import * as $ from 'jquery';
import { PopupService } from './Popup.service';
import { environment  } from 'src/environments/environment';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-Popup',
  templateUrl: './Popup.component.html'
})
export class PopupComponent implements OnInit, OnDestroy {

  latitude;
  longitude;
  markerId;
  currentindex;
  timeout = 1000;
  tempbusinessList :any= [];
  businessList :any= [];
  checkinDistance = environment.checkinDistance;  
  state: any = {
    location: ""
  }
  timeOutVar:any="";loopcount=0;
  constructor(private router: Router,
  public api: CommonapiService,private popupServiceapi: PopupService, private zone: NgZone, private Winfoapi: CommonapiService)
  { 
    
      
  }
  VP_Subscription: Subscription; show = false;data:any="";
  ngOnInit() 
  {
    this.VP_Subscription = this.popupServiceapi.Receive_info.subscribe((value) => {
     // console.log("value", value)
      this.show = true; 
      this.data = value.data;
      console.log(" ma this.data ",  this.data )
      this.latitude = this.data .latitude;
      this.longitude = this.data .longitude;
      this.markerId = this.data .markerId;
      this.getBusiness();  
     
    });
    //console.log('popup' ,this.businessList);
  }

  
  getBusiness(){
    this.businessList=[];
    this.zone.run(() => {

     // alert(this.markerId);
      console.log(this.markerId);
      this.tempbusinessList = this.api.get_local_storage("sales_nearBybusinessdata", true);
      console.log('tempbusinessList popup' ,this.tempbusinessList);
  
      if(this.tempbusinessList != 'undefined')
      {
        this.tempbusinessList.map((x, index) => {
            
              // if(index== this.markerId)
              if(x.latitude == this.latitude && x.longitude == this.longitude)
              { 
                this.businessList.push(x);
                this.currentindex = index;
              }
  
        })      
  
      }
      console.log('popup' ,this.businessList);

    })
  }


  closeDialog($event)
  {
    this.show=false;
    //alert('close')
      //Write your stuff here
   //   this.dialogRef.close(); // <- Closes the dialog
      //this.router.navigateByUrl('msg');
  }


    ngOnDestroy() {
      this._unsubscribe()
    }
    _unsubscribe() {
      this.VP_Subscription.unsubscribe();
    }

}
